import api, { ApiResponse } from "./../api";
import { FeedbackModel } from "./models";

class FeedbackService {
  private static instance: FeedbackService;

  private constructor() {}

  static getInstance(): FeedbackService {
    if (!FeedbackService.instance) {
      FeedbackService.instance = new FeedbackService();
    }

    return FeedbackService.instance;
  }  

  public submitJiraFeedback = async (
    data: FeedbackModel
  ): Promise<ApiResponse<any>> => {
    return await api.post("/jira/feedback", {
      ...data,
      rating: Number(data.rating),
      headers: {
        "content-type": "multipart/form-data"
      }
    });
  };

  public getSubjects = async (): Promise<ApiResponse<any>> => {
    return await api.get("/feedback/subjects");
  };  
}

export default FeedbackService;
